// extracted by mini-css-extract-plugin
export var awardsGrid = "IoT-module--awards-grid--f87f0";